import { styled } from '@zoopla-eng/zds-components/themes';

export const NotificationLink = styled('a', {
    display: 'flex',
    height: '100%',
    justifyContent: 'space-between',
    paddingTop: '$S300',
    paddingBottom: '$S500',
    textDecoration: 'none',
    color: 'inherit',
    borderBottom: '$borderWidths$100 solid $graphicDividerSubtle',
    '&:focus-visible': {
        boxShadow: '$focusRing',
        outline: '$functionalFocus'
    }
});

export const NotificationIconContainer = styled('div', {
    display: 'inline-flex',
    borderRadius: '100%',
    p: '$S200',
    backgroundColor: '$brandPrimaryT3',
    marginRight: '$S400'
});

export const NotificationTitle = styled('p', {
    marginBottom: '$S100',
    lineHeight: '$S400',
    fontWeight: '$400'
});

export const NotificationDescription = styled('p', {
    display: 'block',
    fontSize: '$S400',
    lineHeight: '$S400'
});

export const NotificationActionIcon = styled('div', {
    flexShrink: 0,
    color: '$graphicIconsDark',
    alignSelf: 'center'
});

export const NotificationContent = styled('div', {
    display: 'flex',
    alignItems: 'flex-start',
    marginRight: '$S400'
});

export const MojoImage = styled('img', {
    width: '$L600',
    marginTop: '$S200'
});
